<template>
  <div class="cx-select has-no-style">
    <el-select
      class="style-wrap"
      ref="cxSelectBox"
      :style="getStyle"
      :filterable="hasSearch"
      :remote="!!options.appId"
      :remoteMethod="searchEv"
      style="width: 100%"
      :popper-append-to-body="appendToBody"
      v-model="value"
      :loading="loading"
      :placeholder="placeholderText"
      :clearable="isClearable"
      @focus="focusHandle"
      @change="changeSelectOption"
      @blur="blurhandle"
      v-loadMore="loadSelectOptions"
      @clear="clearFunc"
      :popper-class="popperId"
    >
        <el-option
          v-for="(item, index) in selectOptions"
          :class="item.label == value ? 'selected' : ''"
          :style="getOptionStyle"
          :key="item.label + '_' + index"
          :label="item.label"
          :value="item.label"
          @click.native="selectOptionsFunc"
          v-show="!item.isHide"
        >
        </el-option>
    </el-select>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
import plugins from "./plugin"
import { _debounce } from "utils"
import $ from "jquery"
import dataRenderMixin from "materials/dataRenderMixin"

export default {
  mixins: [eventMixin, plugins, dataRenderMixin],
  props: {
    options: {
      type: Object,
      required: true
    },
    myid: {
      type: Object,
      default: null
    },
    datas: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  mounted() {
    if(this.isBigScreenPreview()){
      this.appendToBody = true
    }else{
      this.appendToBody = false
    }
    this.$initPlugin(this.options?.pluginName)
    if (this.options.noCacheComponent) {
      this.updateData()
    }
    if(this.request_prefix === 'bigScreen'){
      this.isClearable = true
    }
    // 向head中插入popper的指定样式
    const styleLink = document.createElement('style')
    styleLink.type = "text/css"
    styleLink.rel = 'styleSheet'
    styleLink.id = this.popperId
    styleLink.innerHTML = this.getPopperStyle()
    const existedStyleLink = document.getElementById(this.popperId)
    existedStyleLink && (document.head.removeChild(existedStyleLink))
    document.head.appendChild(styleLink)
    // 考虑搜索组件里的下拉框不能切换样式，所以对旧数据进行兼容
    this.handleChangeStyleRef()
  },
  computed: {
    popperId() {
      return 'select_popper' + this.ids.rect_id
    },
    ids() {
      return this.myid
    },
    placeholderText() {
      return this.options.showPlaceHolderText ? this.options.placeholderText : undefined
    },
    showPlaceHolderText() {
      return this.options.showPlaceHolderText
    },
    value: {
      get() {
        // 只有第一次才会默认执行
        if (!this.mounte) {
          this.handleChartEvent(this.options.value)
        }
        return this.options.value
      },
      set(val) {
        this.$changeOptionsEV(val, "value", false, undefined, this.myid, true)
      }
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    backgroundColor() {
      // return this.options.selectBgIsThemeColor
      //   ? this.themeColor
      //   : this.options.selectBgColor && this.options.selectBgColor.color
      //   ? this.options.selectBgColor.color
      //   : this.options.selectBgColor
      return this.$parseColor(this.options.selectBgColor, {
        isThemeColor: this.options.selectBgIsThemeColor
      })
    },
    hasSearch() {
      return this.options.hasSearch
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getStyle() {
      let borderW = "",
        borderLeft = "",
        selectLiBorderW = "",
        selectWidth
      if (Array.isArray(this.options.selectBorderWidth)) {
        this.options.selectBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
        borderLeft = this.options.selectBorderWidth[3] + "px"
      } else {
        borderW += ` ${this.options.selectBorderWidth}px`
        borderLeft = ` ${this.options.selectBorderWidth}px`
      }

      if (Array.isArray(this.options.liBorderWidth)) {
        this.options.liBorderWidth.forEach(item => [(selectLiBorderW += ` ${item}px`)])
        selectWidth = this.options.liBorderWidth[1]+this.options.liBorderWidth[3]
      } else {
        selectLiBorderW += ` ${this.options.liBorderWidth}px`
        selectWidth = this.options.liBorderWidth*2
      }
      const height = this.options.heightType === "自动" ? "auto" : this.options.heightType === "%" ? "100%" : this.options.height + "px"
      return {
        "--placeHolderFontSize": this.options.placeHolderFontSize + "px",
        // "--placeHolderFontColor": this.options.placeHolderFontColor,
        "--placeHolderFontColor": this.$parseColor(this.options.placeHolderFontColor),
        "--placeHolderFontWeight": this.options.placeHolderFontWeight,
        "--placeHolderFontFamily": this.options.placeHolderFontFamily,
        height: height,
        color: this.$parseColor(this.options.selectFontColor),
        fontWeight: this.options.selectFontWeight,
        fontSize: this.options.selectFontSize + "px",
        "--fontSize": this.options.selectFontSize + "px",
        fontFamily: this.options.selectFontFamily,
        background: this.backgroundColor,
        "--boxShadow": this.boxShadowStyle,
        "border-style": this.options.selectBorderStyle,
        // "border-color": this.options.selectBorderIsThemeColor
        //   ? this.themeColor
        //   : this.options.selectBorderColor && this.options.selectBorderColor.color
        //   ? this.options.selectBorderColor.color
        //   : this.options.selectBorderColor,
        "border-color": this.$parseColor(this.options.selectBorderColor, {
          isThemeColor: this.options.selectBorderIsThemeColor
        }),
        "border-width": borderW,
        borderRadius: `${this.options.borderTopLeftRadius}px ${this.options.borderTopRightRadius}px ${this.options.borderBottomRightRadius}px ${this.options.borderBottomLeftRadius}px`,
        "--selectBorderRadius": `${this.options.liBorderTopLeftRadius}px ${this.options.liBorderTopRightRadius}px ${this.options.liBorderBottomRightRadius}px ${this.options.liBorderBottomLeftRadius}px`,
        // "--selectBackground": this.options.liBgIsThemeColor
        //   ? this.themeColor
        //   : this.options.primaryLiBg && this.options.primaryLiBg.color
        //   ? this.options.primaryLiBg.color
        //   : this.options.primaryLiBg,
        "--selectBackground": this.$parseColor(this.options.primaryLiBg, {
          isThemeColor: this.options.liBgIsThemeColor
        }),
        "--selectBorderWidth": selectLiBorderW,
        "--selectBorderStyle": ` ${this.options.liBorderStyle}`,
        // "--selectBorderColor": `${
        //   this.options.liBorderIsThemeColor
        //     ? this.themeColor
        //     : this.options.liBorderColor.color
        //     ? this.options.liBorderColor.color
        //     : this.options.liBorderColor
        // }`,
        "--selectBorderColor": this.$parseColor(this.options.liBorderColor, {
          isThemeColor: this.options.liBorderIsThemeColor
        }),
        "--selectWidth": this.options.liIsSameSize ? "100%" : (this.options.liWidth - selectWidth) + "px",
        "--selectWrapWidth": this.options.liIsSameSize ? "100%" : this.options.liWidth  + "px",
        "--selectMarginLeft": "-" + borderLeft,
        // "--selectActiveBackground": this.options.liBgSltIsThemeColor
        //   ? this.themeColor
        //   : this.options.selectLiBg && this.options.selectLiBg.color
        //   ? this.options.selectLiBg.color
        //   : this.options.selectLiBg,
        "--selectActiveBackground": this.$parseColor(this.options.selectLiBg, {
          isThemeColor: this.options.liBgSltIsThemeColor
        }),
        // "--selectActiveColor": this.options.liSltTextIsThemeColor
        //   ? this.themeColor
        //   : this.options.selectLiColor && this.options.selectLiColor.color
        //   ? this.options.selectLiColor.color
        //   : this.options.selectLiColor,
        "--selectActiveColor": this.$parseColor(this.options.selectLiColor, {
          isThemeColor: this.options.liSltTextIsThemeColor
        }),
        // "--selectHoverBackground": this.options.liBgHovIsThemeColor
        //   ? this.themeColor
        //   : this.options.hoverLiBg && this.options.hoverLiBg.color
        //   ? this.options.hoverLiBg.color
        //   : this.options.hoverLiBg,
        "--selectHoverBackground": this.$parseColor(this.options.hoverLiBg, {
          isThemeColor: this.options.liBgHovIsThemeColor
        }),
        // "--selectHoverColor": this.options.liHovTextIsThemeColor
        //   ? this.themeColor
        //   : this.options.hoverLiColor && this.options.hoverLiColor.color
        //   ? this.options.hoverLiColor.color
        //   : this.options.hoverLiColor,
        "--selectHoverColor": this.$parseColor(this.options.hoverLiColor, {
          isThemeColor: this.options.liHovTextIsThemeColor
        }),
        "--themeColor": this.themeColor,
        opacity: this.options.opacity / 100
      }
    },
    getOptionStyle() {
      let borderW = ""
      if (Array.isArray(this.options.liBorderWidth)) {
        this.options.liBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.liBorderWidth}px`
      }
      return {
        lineHeight: this.options.liIsSameSize ? this.options.height + "px" : this.options.liHeight + "px",
        height: this.options.liIsSameSize ? this.options.height + "px" : this.options.liHeight + "px",
        // "--liFontColor": this.options.liTextIsThemeColor
        //   ? this.themeColor
        //   : this.options.liFontColor.color
        //   ? this.options.liFontColor.color
        //   : this.options.liFontColor,
        "--liFontColor": this.$parseColor(this.options.liFontColor, {
          isThemeColor: this.options.liTextIsThemeColor
        }),
        fontWeight: this.options.liFontWeight,
        fontSize: this.options.liFontSize + "px",
        fontFamily: this.options.liFontFamily,
        // background: this.options.liBgIsThemeColor
        //   ? this.themeColor
        //   : this.options.primaryLiBg.color
        //   ? this.options.primaryLiBg.color
        //   : this.options.primaryLiBg
        background: this.$parseColor(this.options.primaryLiBg, {
          isThemeColor: this.options.liBgIsThemeColor
        }),
      }
    },
    selectOptions() {
      if (this.options.quoteFrom) {
        return this.datas
      } else {
        return this.options.selectOptions
      }
    },
    open: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "open", "open", true)
      },
      set(val) {
        this.$changeOptionsEV(val, "open", false, null, this.myid)
      }
    }
  },
  watch: {
    getStyle() {
      this.updatePopperStyle()
    },
    getOptionStyle() {
      this.updatePopperStyle()
    }
  },
  data() {
    return {
      lastVal: undefined,
      isLast: false,
      totalSelectOptions: 0,
      pageNum: 1,
      loading: false,
      changedValue: false,
      isClearable: false,
      appendToBody: false,
      isLoading: false
    }
  },
  methods: {
    handleChangeStyleRef(){
      if(!this.options.hasOwnProperty("isSystemComponent")){
        this.$changeOptionsEV(
            [true, true, true],
            ["isSystemComponent", "isDefaultComponent", "isIndependenceComponent"], false, null, this.myid, true)
      }
    },
    async searchEv(query) {
      console.log("query", query)
      query = encodeURIComponent(query.trim())
      this.loading = true
      try {
        this.$changeOptionsEV(query, "filterValue", false, null, this.myid, true)
        this.updateData(true)
      } finally {
        this.loading = false
      }
    },
    focusHandle() {
      if (this.hasSearch) {
        this.lastVal = JSON.parse(JSON.stringify(this.value))
        this.value = ""
      }
    },
    blurhandle() {
      if (this.lastVal) {
        this.value = this.lastVal
        this.lastVal = ""
      }
    },
    // 下拉框在控制其它组件的更新
    handleChartEvent(val) {
      const idStr = `container_id_${this.myid.container_id}-rect_id_${this.myid.rect_id}`
      const chartEventBus = window.chartEventBus
      if (chartEventBus && chartEventBus.eventMap[idStr]) {
        chartEventBus.dataMap[idStr] = val
        if (!this.mounte) {
          this.mounte = true
        } else {
          chartEventBus.emit(idStr)
        }
      }
    },
    changeSelectOption(val) {
      if(val === ""){
        return
      }
      this.handleChartEvent(val)
      let url = this.selectOptions.find(options => options.label === val).value
      this.$changeOptionsEV(url, "linkValue", false, null, this.myid, true)
      if (!url) {
        return
      }
      if (this.options?.searchType === "searchSelect") {
        return
      }
      if (this.request_prefix === "bigScreen" && !this.isBigScreenPreview()) {
        return
      }
      if (this.request_prefix !== "bigScreen" && !this.isSsrPage()) {
        return
      }
      if (this.open) {
        if (this.options.openBlankPage) {
          window.open(url, "_blank")
        } else {
          window.location.href = url
          // 加延迟是为了解决下拉【当前页面跳转】点击后还是刷新原本页面的问题
          setTimeout(()=>{
            // 修复下拉组件页面跳转不触发bug
            if (url.includes(window.location.host)) window.location.reload()
          }, 300)
        }
        this.changedValue = true
        setTimeout(() => {
          this.changedValue = false
        }, 300)
      }
    },
    async updateData(isSearch) {
      let newOptData = this.selectOptions
      let status = false
      if (!isSearch && this.hasSearch) {
        status = true
        this.$changeOptionsEV(false, "hasSearch", false, null, this.myid, true)
      }
      // 解决下拉框作为交互响应组件时，接收参数时，清空分页值
      if(isSearch){
        this.pageNum = 1
        this.isLast = false
      }
      this.updateNormalRect
        .call(
          this,
          (datas, totalRecords) => {
            if (this.totalSelectOptions !== totalRecords || isSearch || Number(totalRecords) === 0) {
              this.pageNum = 1
              newOptData = []
              if(Number(totalRecords) === 0){
              //  空数据，清空默认项
                this.$changeOptionsEV("", "value", false, undefined, this.myid, true)
              }
            }
            this.totalSelectOptions = totalRecords
            datas.forEach(item => {
              newOptData.push({
                label: item[Object.keys(item)[0]].value,
                value: item[Object.keys(item)[1]].value
              })
            })
            this.$changeOptionsEV(newOptData, "selectOptions", false, null, this.myid, true)
            this.isLoading = false
            if (datas.length < 15) {
              this.isLast = true
            }
            if (status) {
              this.$changeOptionsEV(true, "hasSearch", false, null, this.myid, true)
            }
          },
          15,
          this.pageNum
        )
        .then(restDataUrl => {
          this.restDataUrl = restDataUrl
        })
        .catch(res => {
          console.log(res)
        })
    },
    loadSelectOptions() {
      if (!this.isLast && !this.isLoading ) {
        this.isLoading = true
        this.pageNum++
        this.updateData()
      }
    },
    //  为了实现下拉框点击跳转页面后，再点击同样的选项继续跳转页面的效果
    selectOptionsFunc() {
      if (this.options.quoteFrom === "cxSelect") {
        // 当前是tab引用select的样式
        let index = this.selectOptions.findIndex(options => options.label === this.value)
        this.$emit("changeSelect", index)
        return
      }
      let url = this.selectOptions.find(options => options.label === this.value).value
      if (!url || this.options?.searchType === "searchSelect") {
        return
      }
      if (this.request_prefix === "bigScreen" && !this.isBigScreenPreview()) {
        return
      }
      if (this.request_prefix !== "bigScreen" && !this.isSsrPage()) {
        return
      }
      if (this.open) {
        if (this.changedValue) {
          return
        }
        if (this.options.openBlankPage) {
          window.open(url, "_blank")
        } else {
          window.location.href = url
          // 加延迟是为了解决下拉【当前页面跳转】点击后还是刷新原本页面的问题
          setTimeout(()=>{
            // 修复下拉组件页面跳转不触发bug
            if (url.includes(window.location.host)) window.location.reload()
          }, 300)
        }
      }
    },
    clearFunc(){
      if (this.isClearable && this.options.noCacheComponent && this.hasSearch) {
        this.$changeOptionsEV("", "filterValue", false, null, this.myid, true)
        this.updateData(true)
      }
    },
    getPopperStyle() {
      const pageWidth = this.$store.state[request_prefix].page.pageWidth
      // 根据当前浏览器尺寸去缩放画布，先将画布移动到画布中心，再以宽度为准进行缩放
      const clientWidth = document.body.clientWidth
      const zoom = clientWidth / pageWidth
      let boxWidth = "auto"
      if(this.isBigScreenPreview()){
        boxWidth = this.$refs.cxSelectBox.$el.clientWidth * zoom
      }
      return `
        .${this.popperId}.el-select-dropdown {
          margin-bottom: 4px;
        }
        .${this.popperId} .el-select-dropdown__item {
          color: ${this.getOptionStyle['--liFontColor']} !important;
          text-align: center;
          box-shadow: ${this.getStyle['--boxShadow']};
        }
        .${this.popperId} .el-select-dropdown__item:hover {
          box-sizing: border-box;
          color: ${this.getStyle['--selectHoverColor']} !important;
          background: ${this.getStyle['--selectHoverBackground']} !important;
        }
        .${this.popperId} .el-select-dropdown__item.selected {
          color: ${this.getStyle['--selectActiveColor']} !important;
          background: ${this.getStyle['--selectActiveBackground']} !important;
        }
        .${this.popperId} .el-select-dropdown__list {
          width: ${this.getStyle['--selectWidth']};
          background-color: ${this.getStyle['--selectBackground']} !important;
          box-sizing: border-box;
          min-width: auto !important;
          overflow: hidden;
          border: none;
          border-radius: 0;
        }
        .${this.popperId}.el-select-dropdown {
          background-color: transparent;
          box-shadow: unset;
          width: ${boxWidth}px
        }
        .${this.popperId} .el-scrollbar {
          border-width: ${this.getStyle['--selectBorderWidth']};
          border-style: ${this.getStyle['--selectBorderStyle']};
          border-color: ${this.getStyle['--selectBorderColor']};
          border-radius: ${this.getStyle['--selectBorderRadius']};
          width: ${this.getStyle['--selectWrapWidth']};
        }
        .${this.popperId} .popper__arrow {
          display: none
        }
      `
    },
    updatePopperStyle() {
      document.getElementById(this.popperId).innerHTML = this.getPopperStyle()
    }
  },
}
</script>

<style scoped>
::v-deep .el-select-dropdown {
  left: 0px !important;
}
::v-deep .el-scrollbar__view {
  margin-bottom: 0px !important;
}
::v-deep .el-select__caret {
  transition: none !important;
}

::v-deep .el-input__inner::placeholder {
  /* WebKit browsers*/
  color: var(--placeHolderFontColor) !important;
  font-size: var(--placeHolderFontSize) !important;
  font-family: var(--placeHolderFontFamily) !important;
  font-weight: var(--placeHolderFontWeight) !important;
}
::v-deep .el-input__inner::-webkit-input-placeholder {
  /* WebKit browsers*/
  color: var(--placeHolderFontColor) !important;
  font-size: var(--placeHolderFontSize) !important;
  font-family: var(--placeHolderFontFamily) !important;
  font-weight: var(--placeHolderFontWeight) !important;
}
::v-deep .el-input__inner:-moz-input-placeholder {
  /* Mozilla Firefox 4 to 18*/
  color: var(--placeHolderFontColor) !important;
  font-size: var(--placeHolderFontSize) !important;
  font-family: var(--placeHolderFontFamily) !important;
  font-weight: var(--placeHolderFontWeight) !important;
}
::v-deep .el-input__inner::-moz-input-placeholder {
  /* Mozilla Firefox 19+*/
  color: var(--placeHolderFontColor) !important;
  font-size: var(--placeHolderFontSize) !important;
  font-family: var(--placeHolderFontFamily) !important;
  font-weight: var(--placeHolderFontWeight) !important;
}

::v-deep .el-input__inner:-ms-input-placeholder {
  /* Internet Explorer 10+*/
  color: var(--placeholderFontColor) !important;
  font-size: var(--placeholderFontSize) !important;
  font-family: var(--placeholderFontFamily) !important;
  font-weight: var(--placeholderFontWeight) !important;
}
::v-deep .el-select, .cx-select {
  height: 100%;
}
::v-deep .el-input {
  height: 100%;
  font-size: inherit;
}
::v-deep .el-select .el-input__suffix-inner {
  position: absolute;
  top: 50%;
  right: 2px;
  transform: translateY(-50%);
}
::v-deep .el-select .el-input__inner {
  color: inherit;
  background-color: inherit;
  font-size: inherit;
  font-weight: inherit;
  border: inherit;
  font-family: inherit;
  height: 100%;
  text-align: center;
  padding-right: 30px;
}
::v-deep .el-select .el-input__inner:hover {
  background: initial;
}
::v-deep .el-select-dropdown__item {
  color: var(--liFontColor) !important;
  text-align: center;
  box-shadow: var(--boxShadow);
}
::v-deep .el-select-dropdown__item:hover {
  box-sizing: border-box;
  color: var(--selectHoverColor) !important;
  background: var(--selectHoverBackground) !important;
}
::v-deep .el-select-dropdown__item.selected {
  color: var(--selectActiveColor) !important;
  background: var(--selectActiveBackground) !important;
}
::v-deep .el-select-dropdown__list {
  width: var(--selectWidth);
  /* border-width: var(--selectBorderWidth);
  border-style: var(--selectBorderStyle);
  border-color: var(--selectBorderColor); */
  background-color: var(--selectBackground) !important;
  box-sizing: border-box;
  min-width: auto !important;
  /* border-radius: var(--selectBorderRadius); */
  overflow: hidden;
}
::v-deep .el-select-dropdown {
  left: var(--selectMarginLeft) !important;
  background-color: transparent;
  top: var(--height) !important;
  box-shadow: unset;
}
::v-deep .el-select .el-input__suffix {
  right: 14px;
}
::v-deep .el-select .el-icon-arrow-up:before {
  content: "\e78f";
}
::v-deep .el-select-dropdown {
  width: 100%;
}
/* 有滚动条时下圆角边框不生效 */
.cx-select ::v-deep .el-scrollbar {
/*.cx-select ::v-deep .el-scrollbar__wrap {*/
  border-width: var(--selectBorderWidth);
  border-style: var(--selectBorderStyle);
  border-color: var(--selectBorderColor);
  border-radius: var(--selectBorderRadius);
  width: var(--selectWrapWidth);
}
.cx-select ::v-deep .el-scrollbar__wrap {
  margin-bottom: -6px !important;
}
  /*下拉框清空图标*/
::v-deep .el-select .el-input .el-select__caret{
  font-size: var(--fontSize);
  width: var(--fontSize);
  height: var(--fontSize);
}
::v-deep .el-select .el-input .el-select__caret.el-icon-:first-child::before{
  content: "\e78f";
}
::v-deep .el-select .el-input.is-focus .el-select__caret.el-icon-:first-child{
  transform: rotateZ(0deg);
}
/* 输入框双击选中时去掉背景 一帆 */
::v-deep .el-select .el-input__inner::selection {
  background: transparent;
}
</style>
